import React from "react";
import {
  errorAlertSvg,
  questionAlertSvg,
  shieldSvg,
  successAlertSvg
} from "../../components/Assets";
import OutlineBlueBtn2 from "../../components/buttons/OutlineBlueBtn2";
import OutlineRedBtn from "../../components/buttons/OutlineRedBtn";
import OutlineSubBtn from "../../components/buttons/OutlineSubBtn";
import getNextMonthDate from "../../utils/getNextMonthDate";
import useAuth from "../../hooks/useAuth";
import { LOCAL_STORAGE_KEYS } from "../../constants/AppConstants";
import moment from "moment";

export function ReviewPopupTimeInfo({ closeModal }) {
  const { ceoInfo } = useAuth();
  const notShowFor1Month = () => {
      localStorage.setItem(
        `${LOCAL_STORAGE_KEYS.PERIODNOTSHOWREVIEWPOPUP}-${ceoInfo.ceo_idx}`,
        `${moment().add(1, 'months').valueOf()}`
      );
    closeModal();
  };
  return (
    <div className="flex flex-col justify-center items-center gap-6">
      <img alt="shield" src={shieldSvg} className="w-12 h-12" />
      <p className="flex flex-col justify-center items-center">
        <b className="mb-2 w-full text-center">
          댓글 상태가 다르게 보일 수 있어요.
        </b>
        <span className="text-center">
          데이터 수집 시점의 차이로 배달 앱의 사장님<br/> 
          사이트와 상태가 다르게 보일 수 있으나 실제<br/>
          로는 정상 반영되고 있으니 안심하세요.        
        </span>
      </p>
      <div className="popup-btns">
        <OutlineSubBtn onClick={closeModal}>닫기</OutlineSubBtn>
        <OutlineBlueBtn2 className="py-3" onClick={notShowFor1Month}>
          한 달간 보지 않기
        </OutlineBlueBtn2>
      </div>
      {/* <input autoFocus={true}></input> */}
    </div>
  );
}

export function ReviewPopupWriteComment({ closeModal, onOk }) {
  const { ceoInfo } = useAuth();
  const notShowFor1Month = () => {
    localStorage.setItem(
      `${LOCAL_STORAGE_KEYS.PERIODNOTSHOWREVIEWPOPUP}-${ceoInfo.ceo_idx}`,
      `${moment().add(1, 'months').valueOf()}`)
    onOk && onOk();
  };
  return (
    <div className="flex flex-col justify-center items-center gap-6">
      <img alt="shield" src={shieldSvg} className="w-12 h-12" />
      <p className="flex flex-col justify-center items-center">
        <b className="mb-2 w-full text-center">
          댓글 상태가 다르게 보일 수 있어요.
        </b>
        <span className="text-center">
          데이터 수집 시점의 차이로 배달 앱의 사장님<br/> 
          사이트와 상태가 다르게 보일 수 있으나 실제<br/>
          로는 정상 반영되고 있으니 안심하세요.  
        </span>
      </p>
      <div className="popup-btns">
        <OutlineSubBtn onClick={closeModal}>닫기</OutlineSubBtn>
        <OutlineBlueBtn2 className="py-3" onClick={notShowFor1Month}>
          한 달간 보지 않기
        </OutlineBlueBtn2>
      </div>
      {/* <input autoFocus={true}></input> */}
    </div>
  );
}

export function ReviewPopupQuestion({ closeModal, onOk }) {
  return (
    <div className="flex flex-col justify-center items-center gap-6">
      <img alt="question" src={questionAlertSvg} className="w-12 h-12" />
      <p className="flex flex-col justify-center items-center">
        <b className="mb-2 w-full text-center">이 댓글로 등록하시겠어요?</b>
        <span className="text-center">
          현재 작성된 댓글을 사장님 사이트에 전송합니다. 계속하시겠어요?
        </span>
      </p>
      <div className="popup-btns">
        <OutlineSubBtn onClick={closeModal}>취소</OutlineSubBtn>
        <OutlineBlueBtn2 className="py-3" onClick={onOk}>계속</OutlineBlueBtn2>
      </div>
    </div>
  );
}

export function ReviewPopupSuccess({ closeModal }) {
  return (
    <div className="flex flex-col justify-center items-center gap-6">
      <img alt="success" src={successAlertSvg} className="w-12 h-12" />
      <p className="flex flex-col justify-center items-center">
        <b className="mb-2 w-full text-center">댓글 등록이 요청되었어요!</b>
        <span className="text-center">
          등록 완료까지 최대 한 시간이 소요돼요.
        </span>
      </p>
      <div className="popup-btns">
        <OutlineBlueBtn2 className="py-3" onClick={closeModal}>확인</OutlineBlueBtn2>
      </div>
    </div>
  );
}

export function ReviewPopupEditSuccess({ closeModal }) {
  return (
    <div className="flex flex-col justify-center items-center gap-6">
      <img alt="success" src={successAlertSvg} className="w-12 h-12" />
      <p className="flex flex-col justify-center items-center">
        <b className="mb-2 w-full text-center">댓글 수정이 완료되었어요!</b>
        <span className="text-center">
          수정된 댓글로 등록 요청하실 수 있어요.
        </span>
      </p>
      <div className="popup-btns">
        <OutlineBlueBtn2 className="py-3" onClick={closeModal}>확인</OutlineBlueBtn2>
      </div>
    </div>
  );
}

export function ReviewPopupExclude({ closeModal }) {
  return (
    <div className="flex flex-col justify-center items-center gap-6">
      <img alt="exclude" src={errorAlertSvg} className="w-12 h-12" />
      <p className="flex flex-col justify-center items-center">
        <b className="mb-2 w-full text-center">
          추천 댓글이 삭제되고 아무런 댓글도 등록되지 않아요.
        </b>
        <span className="text-center">
          댓글 등록 제외 시 해당 댓글은 더 이상 스폰지에서 관리 하실 수 없어요.
        </span>
      </p>
      <div className="popup-btns">
        <OutlineSubBtn onClick={closeModal}>취소</OutlineSubBtn>
        <OutlineBlueBtn2 className="py-3" onClick={closeModal}>등록 제외</OutlineBlueBtn2>
      </div>
    </div>
  );
}

export function ReviewPopupNotInputButPost({ closeModal }) {
  return (
    <div className="flex flex-col justify-center items-center gap-6">
      <img alt="exclude" src={errorAlertSvg} className="w-12 h-12" />
      <p className="flex flex-col justify-center items-center">
        <b className="mb-2 w-full text-center">
          등록하실 내용을 입력해 주세요.
        </b>
        <span className="text-center">
          댓글 내용이 입력되어야 등록이 가능해요.
        </span>
      </p>
      <div className="popup-btns">
        <OutlineBlueBtn2 className="py-3" onClick={closeModal}>확인</OutlineBlueBtn2>
      </div>
    </div>
  );
}

export function ReviewPopupPostMoreThan1000Chars({ closeModal }) {
  return (
    <div className="flex flex-col justify-center items-center gap-6">
      <img alt="exclude" src={errorAlertSvg} className="w-12 h-12" />
      <p className="flex flex-col justify-center items-center">
        <b className="mb-2 w-full text-center">1,000자 이내로 입력해 주세요.</b>
        <span className="text-center">
          댓글은 공백 포함 최대 1,000자 까지만 입력하실 수 있어요.
        </span>
      </p>
      <div className="popup-btns">
        <OutlineBlueBtn2 className="py-3" onClick={closeModal}>확인</OutlineBlueBtn2>
      </div>
    </div>
  );
}

export function ReviewPopupEditFail({ closeModal,desc }) {
  return (
    <div className="flex flex-col justify-center items-center gap-6">
      <img alt="exclude" src={errorAlertSvg} className="w-12 h-12" />
      <p className="flex flex-col justify-center items-center">
        <b className="mb-2 w-full text-center">댓글 수정에 실패했어요.</b>
        <span className="text-center"  dangerouslySetInnerHTML={{ __html:desc}}>
        
        </span>
      </p>
      <div className="popup-btns">
        <OutlineBlueBtn2 className="py-3" onClick={closeModal}>확인</OutlineBlueBtn2>
      </div>
    </div>
  );
}

export function ReviewPopupBack({ closeModal, onOk }) {
  return (
    <div className="flex flex-col justify-center items-center gap-6">
      <img alt="exclude" src={errorAlertSvg} className="w-12 h-12" />
      <p className="flex flex-col justify-center items-center">
        <b className="mb-2 w-full text-center">
          작성 중 내용이 저장되지 않았어요.
        </b>
        <span className="text-center">
          리뷰 목록 페이지로 돌아가시겠습니까?
        </span>
      </p>
      <div className="popup-btns">
        <OutlineSubBtn onClick={closeModal}>취소</OutlineSubBtn>
        <OutlineBlueBtn2 className="py-3" onClick={onOk}>이동</OutlineBlueBtn2>
      </div>
    </div>
  );
}

export function ReviewPopupDeleteAll({ closeModal, onOk }) {
  return (
    <div className="flex flex-col justify-center items-center gap-6">
      <img alt="exclude" src={errorAlertSvg} className="w-12 h-12" />
      <p className="flex flex-col justify-center items-center">
        <b className="mb-2 w-full text-center">입력된 내용을 지우시겠어요?</b>
        <span className="text-center">
          지금까지 작성하신 내용이 전부 지워져요.
        </span>
      </p>
      <div className="popup-btns">
        <OutlineSubBtn onClick={closeModal}>취소</OutlineSubBtn>
        <OutlineRedBtn onClick={onOk}>이동</OutlineRedBtn>
      </div>
    </div>
  );
}

// REVIEW SETTING POPUP

export function ReviewSettingPopupSettingDaySuccess({ closeModal }) {
  return (
    <div className="flex flex-col justify-center items-center gap-6">
      <img alt="success" src={successAlertSvg} className="w-12 h-12" />
      <p className="flex flex-col justify-center items-center">
        <b className="mb-2 w-full text-center">
          자동 등록일 설정이 완료되었어요!
        </b>
        <span className="text-center">
          다음 리뷰부터 자동 등록일이 적용돼요.
        </span>
      </p>
      <div className="popup-btns">
        <OutlineBlueBtn2 className="py-3" onClick={closeModal}>확인</OutlineBlueBtn2>
      </div>
    </div>
  );
}
export function ReviewSettingPopupAdditionalCommentDuplicate({ closeModal }) {
  return (
    <div className="flex flex-col justify-center items-center gap-6">
      <img alt="exclude" src={errorAlertSvg} className="w-12 h-12" />
      <p className="flex flex-col justify-center items-center">
        <b className="mb-2 w-full text-center">다른 제목을 입력해 주세요.</b>
        <span className="text-center">이미 동일한 제목이 사용되고 있어요.</span>
      </p>
      <div className="popup-btns">
        <OutlineBlueBtn2 className="py-3" onClick={closeModal}>확인</OutlineBlueBtn2>
      </div>
    </div>
  );
}

export function ReviewSettingPopupAdditionalCommentRemoved({
  closeModal,
  onOk,
}) {
  return (
    <div className="flex flex-col justify-center items-center gap-6">
      <img alt="exclude" src={errorAlertSvg} className="w-12 h-12" />
      <p className="flex flex-col justify-center items-center">
        <b className="mb-2 w-full text-center">
          추천 댓글이 삭제되고 아무런 댓글도 등록되지 않아요.
        </b>
        <span className="text-center">
          댓글 등록 제외 시 해당 댓글은 더 이상 스폰지에서 관리 하실 수 없어요.
        </span>
      </p>
      <div className="popup-btns">
        <OutlineSubBtn onClick={closeModal}>취소</OutlineSubBtn>
        <OutlineRedBtn onClick={onOk}>등록 제외</OutlineRedBtn>
      </div>
    </div>
  );
}
export function ReviewSettingPopupAdditionalCommentAddSuccess({ closeModal }) {
  return (
    <div className="flex flex-col justify-center items-center gap-6">
      <img alt="success" src={successAlertSvg} className="w-12 h-12" />
      <p className="flex flex-col justify-center items-center">
        <b className="mb-2 w-full text-center">
          자동 등록일 설정이 완료되었어요!
        </b>
        <span className="text-center">
          다음 리뷰부터 자동 등록일이 적용돼요.
        </span>
      </p>
      <div className="popup-btns">
        <OutlineBlueBtn2 className="py-3" onClick={closeModal}>확인</OutlineBlueBtn2>
      </div>
    </div>
  );
}
